import { render, staticRenderFns } from "./MembershipHubs.vue?vue&type=template&id=b867d7cc&"
import script from "./MembershipHubs.vue?vue&type=script&lang=js&"
export * from "./MembershipHubs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports